import { useEffect, useState } from "react";
import { getToken } from "utils/common-util";

function useAuth() {
  const [token, setToken] = useState(() => getToken())

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
     // token is 'string' so if there is no any change then every re-render will be same as previous.
    setToken(getToken())
  })

  return token;
}

export default useAuth;